import stringify from 'json-stable-stringify'

import { TokenParams } from 'modules/types/tokens'

export const getTokenKey = (params: TokenParams): string => {
  return stringify(params).replace('/\s/g', '')
}
